<div
  *ngIf="workspace"
  class="db-workspace-popup"
  [ngClass]="{'none-events': showActivityLogTour || userSubscription?.boosterBetaClient}">
  <input type="checkbox" id="db-workspace-popup__trigger" class="db-workspace-popup__trigger"
         (change)="changeValue($event)" [checked]="isChecked || (showActivityLogTour && !isMobile)">
  <label for="db-workspace-popup__trigger" [ngClass]="{'db-opened': isChecked && !userSubscription?.boosterBetaClient
       && ((workspace.roleId === workspaceRoles.OWNER || workspace.roleId === workspaceRoles.COMPANY_ADMIN)
       && (!user?.hostingTrialExpired
       || userSubscription?.type === userSubscriptionType.ONE_PRODUCT
       || userSubscription?.type === userSubscriptionType.PREMIUM)), 'db-has-workspace-dropdown': workspace.roleId === workspaceRoles.OWNER || workspace.roleId === workspaceRoles.COMPANY_ADMIN}">
   <div class="db-workspace-popup__picture"
        *ngIf="([userSubscriptionType.FREE, userSubscriptionType.PLATFORM, userSubscriptionType.BOOSTER].includes(user?.planType)) && isMobile">
      <div>
        <span *ngIf="!workspace.workspaceLogo"
              [ngStyle]="{backgroundColor: workspace.workspaceColor}">{{user?.firstName.charAt(0).toUpperCase()}}</span>
        <div *ngIf="!!workspace.workspaceLogo"
             [ngStyle]="{backgroundImage: 'url(&quot;' + workspace.workspaceLogo + '&quot;)'}"></div>
      </div>
    </div>
    <div class="db-workspace-popup__info">
      <b [innerHTML]="'text_workspace' | dbText: {workspaceName: user?.firstName}"></b>
    </div>
    <i class="db-icon db-icon-ds-arrow-small"
       *ngIf="!userSubscription?.boosterBetaClient && !userSubscription?.boosterBetaClient
       && ((workspace.roleId === workspaceRoles.OWNER || workspace.roleId === workspaceRoles.COMPANY_ADMIN)
       && (!user?.hostingTrialExpired
       || userSubscription?.type === userSubscriptionType.ONE_PRODUCT
       || userSubscription?.type === userSubscriptionType.PREMIUM))"
       [ngClass]="{'db-toggled': isChecked}"></i>
  </label>

  <div class="db-workspace-popup__popup-wrapper"
       *ngIf="!userSubscription?.boosterBetaClient
       && ((workspace.roleId === workspaceRoles.OWNER || workspace.roleId === workspaceRoles.COMPANY_ADMIN)
       && (!user?.hostingTrialExpired
       || userSubscription?.type === userSubscriptionType.ONE_PRODUCT
       || userSubscription?.type === userSubscriptionType.PREMIUM))"
       [ngClass]="{'db-workspace-popup__popup-wrapper-hide': !isChecked}">
    <div class="db-workspace-popup__popup-content">
      <div class="db-workspace-popup__popup-header">
        <div class="db-workspace-popup__popup-header-intro">
          <div class="db-workspace-popup__picture">
            <div>
              <span [ngStyle]="{backgroundColor: workspace.workspaceColor}" *ngIf="!workspace.workspaceLogo">{{user?.firstName.charAt(0).toUpperCase()}}</span>
              <div *ngIf="!!workspace.workspaceLogo"
                   [ngStyle]="{backgroundImage: 'url(&quot;' + workspace.workspaceLogo + '&quot;)'}"></div>
            </div>
          </div>
          <div class="db-workspace-popup__info">
            <b [innerHTML]="'text_workspace' | dbText: {companyName: user?.firstName}"></b>
          </div>
        </div>
      </div>

      <div class="db-workspace-popup__plan-upgrade"
           *ngIf="hasUpgrade && !userSubscription?.isDedicatedVM && !userSubscription?.trialBoosterClient && userSubscription?.type !== userSubscriptionType.BOOSTER">
        <p>{{'text_workspaceUpdate' | dbText: {
          type:userSubscription?.type === userSubscriptionType.FREE ?
            'Free Plan' : (userSubscription?.plan?.title + (userSubscription?.type !== userSubscriptionType.ONE_PRODUCT ? ' Plan' : ''))
        } }}
          <a [routerLink]="![userSubscriptionStatus.canceled, userSubscriptionStatus.failed, userSubscriptionStatus.expired].includes(userSubscription.status) || userSubscription?.apiResellerFree ? ['/upgrade-plan'] : ['/workspace/subscription-plan']"
             [queryParams]="{currentUser: true}"
             (click)="hidePopup(); sendFreeUpgradeEvent()"
             [innerHTML]="user?.planType === userSubscriptionType.FREE ? 'Pricing' : 'text_upgrade' | dbText"></a>
        </p>
      </div>


      <div class="db-workspace-popup__plan-upgrade"
           *ngIf="userSubscription?.trialBoosterClient || userSubscription?.boosterProClient">
        <span class="current-plan">{{'text_currentPlan' | dbText}}</span>
        <div class="db-workspace-popup__plan-names"
             [ngClass]="{'column-reverse': userSubscription?.boosterProClient}">
          <p class="space-between">{{'text_workspaceUpdatePro' | dbText: {
            type: !userSubscription?.boosterProClient ?
              'Booster Free' : 'Booster ' + userSubscription?.boosterCategory
          } }}
            <a *ngIf="!trialUpgradable && (!userSubscription?.boosterProClient || (userSubscription?.boosterProClient && userSubscription?.boosterCategory !== UserSubscriptionCategory.AGENCY))"
               [routerLink]="![userSubscriptionStatus.canceled,
            userSubscriptionStatus.failed,
            userSubscriptionStatus.expired].includes(userSubscription.status) ? ['/upgrade-plan'] : ['/workspace/subscription-plan']"
               [queryParams]="{currentUser: true}"
               (click)="hidePopup(); sendFreeUpgradeEvent()"
               [innerHTML]="'text_upgrade'| dbText"></a>
          </p>
        </div>
      </div>

      <div class="db-upgrade-booster" *ngIf="trialUpgradable">
        <div>
        <a [routerLink]="![userSubscriptionStatus.canceled, userSubscriptionStatus.failed,
            userSubscriptionStatus.expired].includes(userSubscription.status) ? ['/upgrade-plan'] :
            ['/workspace/subscription-plan']"
           [queryParams]="{currentUser: true}"
           (click)="hidePopup(); sendFreeUpgradeEvent()">{{'text_workspaceUpdateAiAssistant' | dbText}}</a>
        <i class="db-icon db-icon-ds-diamond"></i>
        </div>
      </div>

      <div class="db-workspace-popup__link-users"
           [ngClass]="{'with-shadow': showWorkspaceTour && !isMobile && hasCloseButton, 'hide-border': showActivityLogTour}"
           *ngIf="workspace.roleId === workspaceRoles.OWNER
           && ((!expiredSubscr && user?.platformClient)
           || (userSubscription?.trialClient && !user?.hostingTrialExpired)
           || userSubscription?.boosterProClient)">
        <small class="mb5" [innerHTML]="'text_client-management-tooltip-title' | dbText"></small>
        <div>
          <a [routerLink]="['/user-management']" (click)="hidePopup()" [innerHTML]="'text_sidebar.users' | dbText"></a>
          <button class="ds-label" [routerLink]="['/user-management']" [queryParams]="{from: 'workspace_popup'}"
                  (click)="hidePopup()">
            <span><img src="assets/images/icons/add_users.svg" alt="">invite</span>
          </button>
        </div>
      </div>

      <div class="db-workspace-popup__link-main activity-log" [ngClass]="{'with-shadow': showActivityLogTour}"
           *ngIf="workspace.roleId === workspaceRoles.OWNER && !userSubscription?.trialBoosterClient &&
           !userSubscription?.boosterProClient">
        <a [routerLink]="['/activity-log']" [innerHTML]="'text_activityLog' | dbText"
           (click)="showActivityLogTour ? gotItActivityLog() : hidePopup()">
        </a>
      </div>

      <div class="db-workspace-popup__link-main" *ngIf="!userSubscription?.boosterProClient &&
      !userSubscription?.trialBoosterClient && !userSubscription?.apiResellerFree && !userSubscription?.apiResellerPro">
        <a [routerLink]="['/white-label']" [innerHTML]="'text_whiteLabel' | dbText" (click)="hidePopup()"></a>
      </div>
      <db-workspace-popup-first-time *ngIf="showActivityLogTour && !isMobile"
                                     (closeFirstTimePopup)="closeFirstTimeActivityLogPopUp($event)"
                                     [userLocalStorage]="userLocalStorage" [title]="'text_welcomeOwnActivityLog' | dbText"
                                     [desc]="'text_welcomeOwnActivityLogDesc' | dbText"
                                     [buttonText1]="'text_emailVerification.gotIt' | dbText"
                                     [invited]="!isOwnWorkspaceActive || (workspace.roleId !== workspaceRoles.OWNER && workspace.roleId !== workspaceRoles.COMPANY_ADMIN)"
                                     [activityLogTour]="true">
      </db-workspace-popup-first-time>
<!--      <db-workspace-popup-first-time (closeFirstTimePopup)="closeFirstTimePopUp($event)"-->
<!--                                     *ngIf="showWorkspaceTour && !isMobile"-->
<!--                                     [userLocalStorage]="userLocalStorage"-->
<!--                                     [hasCloseButton]="hasCloseButton"-->
<!--                                     [title]="firstTimePopupTitle"-->
<!--                                     [paidClient]="userSubscription?.subscriptionId !== userSubscriptionIds.TRIAL"-->
<!--                                     [clientRole]="user?.signUpFor?.Role?.id"-->
<!--                                     [currentSubscription]="userSubscription"-->
<!--                                     [desc]="firstTimePopupDesc"-->
<!--                                     [upgraded]="!hasUpgrade"-->
<!--                                     [buttonText1]="firstTimePopupButton1"-->
<!--                                     [buttonText2]="firstTimePopupButton2"-->
<!--                                     [hasSwitch]="showSwitch">-->
<!--      </db-workspace-popup-first-time>-->

      <div class="db-workspace-settings">
        <p>{{'text_workspaceSettings' | dbText}}</p>
        <ul>
          <li class="db-workspace-popup__link-settings" *ngIf="workspace.roleId === workspaceRoles.OWNER">
            <a (click)="hidePopup('/workspace/workspace-settings')">{{'text_workspaceInfo' | dbText}}</a>
          </li>
          <li class="db-workspace-popup__link-settings">
            <a [routerLink]="['/workspace/subscription-plan']"
               (click)="hidePopup()">{{'text_subscriptionPlan' | dbText}}</a>
          </li>
          <li class="db-workspace-popup__link-settings"
              *ngIf="!userSubscription?.trialClient && !userSubscription?.trialBoosterClient && !userSubscription?.freeBaseClient
              && userSubscription?.subscriptionId !== Config.defaultStarterPlanId">
            <a [routerLink]="['/workspace/billing-details']"
               (click)="hidePopup()">{{'text_billingDetails' | dbText}}</a>
          </li>
          <li class="db-workspace-popup__link-settings"
              *ngIf="!userSubscription?.trialClient && !userSubscription?.trialBoosterClient && !userSubscription?.freeBaseClient
              && userSubscription?.subscriptionId !== Config.defaultStarterPlanId">
            <a [routerLink]="['/workspace/payment-methods']"
               (click)="hidePopup()">{{'text_managePaymentTitlePaypal' | dbText}}</a>
          </li>
          <li class="db-workspace-popup__link-settings"
              *ngIf="!userSubscription?.trialClient && !userSubscription?.trialBoosterClient && !userSubscription?.freeBaseClient
              && userSubscription?.subscriptionId !== Config.defaultStarterPlanId && !isMobile">
            <a [routerLink]="['/workspace/invoices']"
               (click)="hidePopup()">{{'text_invoices' | dbText}}</a>
          </li>
        </ul>

      </div>
    </div>

    <div *ngIf="!isOwnWorkspaceActive && user?.planType !== userSubscriptionType.FREE && user?.planType !== userSubscriptionType.PLATFORM" (click)="addOwnWorkspace()"
         class="db-workspace-popup__add-own-workspace db-workspace-popup__popup-content">
      <span [innerHTML]="'text_addOwnWorkspace' | dbText"></span>
    </div>
  </div>

</div>
<div class="db-cover-content" *ngIf="showActivityLogTour && !isMobile" (click)="hasCloseButton && gotItActivityLog()"></div>

